export const KEY_CHAT_HISTORY = 'chat-history'

export const KEY_CHAT_HISTORY_BY_ID = 'chat-history-by-chat-id'
